$('#modal-design-dialog').on('show.bs.modal', function (e) {
    updateDesignDialog()
})

function updateDesignDialog() {
    document.getElementById('modal-design-dialog-label').innerHTML = "Design Specification - " + activeProject.designTypeStr //+ activeProject.material['Type'];
    // if active project is custom or european steel disable LRFD and ASD and show message
    if(activeProject.isWood || activeProject.isNorthAmericanSteel || activeProject.isEngineeredLumber) {
        document.getElementById('design-available-warning').classList.add('hidden')
        document.getElementById('lrfd-combinations-tab').classList.remove('hidden')
        document.getElementById('asd-combinations-tab').classList.remove('hidden')
        if(activeProject.isLRFD) {
            toggleDesignButton(document.getElementById('lrfd-combinations-tab'))
        } else if(activeProject.isASD) {
            toggleDesignButton(document.getElementById('asd-combinations-tab'))
        } else {
            toggleDesignButton(document.getElementById('basic-design-tab'))
        }
    } else {
        document.getElementById('design-available-warning').classList.remove('hidden')
        document.getElementById('lrfd-combinations-tab').classList.add('hidden')
        document.getElementById('asd-combinations-tab').classList.add('hidden')
        document.getElementById('design-dialog-warning-text').innerHTML = "Only Basic Design is available for " +
            activeProject.material['Type'] + " shapes."
        toggleDesignButton(document.getElementById('basic-design-tab'))
    }
    updateLoadCombinationTableHeader()
    updateLoadCombinationTable()
    
}

function openModalDesignDialog() {
   updateDesignDialog()
    $('#modal-design-dialog').modal('show')
}

function updateLoadCombinationTableHeader() {
    var design = activeProject.design
    if (design.designType === 'None') {
        let str = '<div>Load Cases</div><small>click individual load cases below to exclude</small>'
        document.getElementById('load-combination-table-header').innerHTML = str
        return
    }

    var title = `Use ${design.designType} Equations`
    var str ='<div><label class="checkbox-inline"><input type="checkbox" id="use-load-combo-equations" ' 
    str += 'onclick="onLoadCombinationEquationsClick();">'
    str += `${title} <br><small>click individual load cases below to exclude</small></label></div>`;
    if( (activeProject.isWood || activeProject.isEngineeredLumber) && (activeProject.isLRFD || activeProject.isASD) ) {
        str += '<input id="use-lambda-or-cd" type="checkbox" onclick="configureLambdaOrCdFields();"/>';
        str += activeProject.isLRFD ? ' Use &lambda;' : ' Use Cd';
    }

    document.getElementById('load-combination-table-header').innerHTML = str
    
    var useEquations = (design.loadCombination !== null && design.loadCombination.name !== 'No Combos');
    document.getElementById('use-load-combo-equations').checked = useEquations
}

function lambdaOrCdValue(loadCombination, loadIndex) {
    switch(loadCombination.name) {
        case 'LRFD': return loadCombination.prettyEquations[loadIndex]['lambda']
        case 'ASD' : return loadCombination.prettyEquations[loadIndex]['Cd']
        default: return 1.0
    }
}

function updateLoadCombinationTable() {
    // Show nicely formated Equations
    var design = activeProject.design;
    if (design.loadCombination === null) {
        return;
    }

    var str = '<table class="table">';

    for( var i = 0; i < design.loadCombination.prettyEquations.length; i++ ) {
        if(design.loadCombination.prettyEquations[i]["common"] === false ) {
            continue;
        }
        str += `<tr style="padding: 6px;" class="${design.loadCombination.prettyExclude[i] ? 'text-muted' : ''}" id="load-combination-row-${i}">`
        str += `<td style="padding: 6px;" onclick="toggleLoadCombinationEquation(${i});">`
        str += `<span id="load-combination-check-${i}" class="${design.loadCombination.prettyExclude[i] ? '' : 'fa fa-check'}"> </span> `
        str += `${design.loadCombination.prettyEquations[i]["EQ"]}</td><td style="padding: 6px;">`
        str += `<input class='${activeProject.isWood || activeProject.isEngineeredLumber ? '' : 'hidden'}' id='lambda-or-cd-${i}' type='text' `
        str += `value='${design.loadCombination.lambdaOrCdValue(i)}' onchange='updateLambdaOrCd(${i});'/>`
        str += "</td></tr>"
    }
    str += "</table>"
    document.getElementById('load-combination-table').innerHTML = str

    configureLambdaOrCdFields()
    document.dispatchEvent(new CustomEvent('design-type-changed'))
}

function onLoadCombinationEquationsClick() {
    const useEquations = document.getElementById('use-load-combo-equations').checked
    if(useEquations === false) {
        activeProject.design.loadCombination = noCombinations;
    } else if(activeProject.isLRFD) {
        activeProject.design.loadCombination = lrfdCombinations;
    } else if(activeProject.isASD) {
        activeProject.design.loadCombination = asdCombinations;
    }
    updateLoadCombinationTable();
}


function toggleLoadCombinationEquation(index) {
    document.getElementById(`load-combination-check-${index}`).classList.toggle('fa')
    document.getElementById(`load-combination-check-${index}`).classList.toggle('fa-check')
    document.getElementById(`load-combination-row-${index}`).classList.toggle('text-muted')
    activeProject.design.loadCombination.togglePrettyExclude(index);
}

function configureLambdaOrCdFields() {
    if(!activeProject.isWood && !activeProject.isEngineeredLumber) {
        return
    }
    const useLambda = document.getElementById('use-lambda-or-cd') ? document.getElementById('use-lambda-or-cd').checked : false
    activeProject.design.useLambdaOrCd = useLambda
    for( var i = 0; i < activeProject.design.loadCombination.prettyEquations.length; i++ ) {
        if( activeProject.design.loadCombination.prettyEquations[i]["common"] === false ) {
            continue;
        }
        if( useLambda) {
            document.getElementById(`lambda-or-cd-${i}`).classList.remove('hidden')
        } else {
            document.getElementById(`lambda-or-cd-${i}`).classList.add('hidden')
        }
    }
}

function toggleDesignButton(button) {
    document.getElementById('lrfd-combinations-tab').classList.remove('btn-primary')
    document.getElementById('lrfd-combinations-tab').classList.add('btn-default')
    document.getElementById('asd-combinations-tab').classList.remove('btn-primary')
    document.getElementById('asd-combinations-tab').classList.add('btn-default')
    document.getElementById('basic-design-tab').classList.remove('btn-primary')
    document.getElementById('basic-design-tab').classList.add('btn-default')
    if(button) {
        button.classList.add('btn-primary')
    }
}

function onLRFDDesignClick(button) {
    activeProject.design.designType = 'LRFD';
    activeProject.design.loadCombination = lrfdCombinations
    updateLoadCombinationTableHeader();
    updateLoadCombinationTable();
    markBeamDesignNeedsSaved();
    toggleDesignButton(button)
}

function onASDDesignClick(button) {
    activeProject.design.designType = 'ASD';
    activeProject.design.loadCombination = asdCombinations
    updateLoadCombinationTableHeader();
    updateLoadCombinationTable();
    markBeamDesignNeedsSaved();
    toggleDesignButton(button)
}

function onNoDesignClick() {
    activeProject.design.designType = 'None';
    activeProject.design.loadCombination = noCombinations
    updateLoadCombinationTableHeader();
    updateLoadCombinationTable();
    markBeamDesignNeedsSaved();
    toggleDesignButton(document.getElementById('basic-design-tab'))
}

function updateDeflectionLimit() {
    let id = 'live-load-deflection-limit-input'
    if(validateRequiredInput(id) && validateMinimum(id, 1)) {
        activeProject.design.liveLoadLimit = parseInt(document.getElementById(id).value)
    } else { 
        return
    }
    id = 'dead-plus-live-load-deflection-limit-input'
    if(validateRequiredInput(id) && validateMinimum(id, 1)) {
        activeProject.design.deadPlusLiveLoadLimit = parseInt(document.getElementById(id).value)
    } else { 
        return
    }
    id = 'snow-or-wind-load-deflection-limit-input'
    if(validateRequiredInput(id) && validateMinimum(id ,1)) {
        activeProject.design.snowOrWindLoadLimit = parseInt(document.getElementById(id).value)
    } else { 
        return
    }
    id = 'total-load-deflection-limit-input'
    if(validateRequiredInput(id) && validateMinimum(id, 1)) {
        activeProject.design.totalLoadLimit = parseInt(document.getElementById(id).value)
    } else { 
        return
    }
    document.dispatchEvent(new CustomEvent('design-deflection-limits-changed'))
}
